import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import LocaleTooling from '../../../tooling/localeTooling';

import Button from '../common/inputs/button';
import Select from '../common/inputs/select';
import CheckBox from '../common/inputs/checkBox';
import FetchAutocompleteList from '../common/inputs/fetchAutocompleteList';
import SelectWithTextBoxInput from '../common/inputs/selectWithTextBoxInput';

const Filters = props => {
  const {
    onChangeFilter,
    filterValues,
    groupsData,    
    modelsData,
    periodsData,
    calculationUnitsData,
    calculationUnitsFetchAction,
    calculationUnitsLoading,
    loadingCalculationsButton,
    loadingGroups,
    handleLoadCalculations,
    disabledPeriodSelector
  } = props;
  return (
    <div className="calculations_history_filter_wrapper">
      <Select 
        className="calculations_history_filters_wrapper_period_selector"
        disabled={disabledPeriodSelector}
        value={filterValues["filterPeriod"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="calculationsHistory.filterPeriodsLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(periodsData, "id", "name")}
        data-path="filterPeriod"
      />
      <h3>{LocaleTooling.getCalculationUnitContextLocale(<FormattedMessage id="calculationsHistory.filterTitle"/>)}</h3>
      <Select
        className="calculations_history_filters_wrapper_group_selector"
        value={filterValues["filterGroup"]}
        disabled={loadingGroups || !filterValues["filterPeriod"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="calculationsHistory.filterGroupsLabel"/>}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(groupsData, "id", "name")}
        data-path="filterGroup"
      />
      <Select 
        value={filterValues["criteria"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="calculationsHistory.calculationUnitFilterCriteriaLabel"/>}
        options={InterfaceTooling.getSelectArray("calculationFilters.calculationUnitFilter", "calculationsHistory.calculationUnitFilterCriteria", false)}
        data-path="criteria"
      />
      {(filterValues["criteria"]!="" && filterValues["criteria"]!=Constants.calculationFilters.calculationUnitFilter.ALL) && (
        <FetchAutocompleteList        
          values={filterValues["calculationUnitsSelected"]}
          onChange={onChangeFilter}
          addSelectLocale={LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({id:"calculationsHistory.calculationUnitFilterFinderLabel"}))}
          options={InterfaceTooling.getSelectArrayFromArrayOfObjects(calculationUnitsData, "id", "name", false)}
          valueAccesor={"id"}
          labelAccesor={"name"}
          fetchListAction={calculationUnitsFetchAction}
          loadingFetch={calculationUnitsLoading}
          data-path="calculationUnitsSelected"
        />
      )} 
      <h3 className="other_filters_title">{<FormattedMessage id="calculationsHistory.otherFiltersTitle"/>}</h3>
      <SelectWithTextBoxInput
        values={filterValues["filterPolynomial"]}
        onClickOption={onChangeFilter}
        addSelectLocale={ intl.formatMessage({ id: "calculationsHistory.filterModelsLabel" })}
        options={InterfaceTooling.getSelectArrayFromArrayOfObjects(modelsData, "id", "name", false)}
        onClearTextCallback={onChangeFilter}
        data-path={"filterPolynomial"}
        allowDisplayOptionsButton={true}
      />
      <CheckBox 
        value={filterValues["showOnlyWithErrorsFilter"]}
        onChange={onChangeFilter}
        labelLocale={<FormattedMessage id="calculationsHistory.filterOnlyErrors"/>}
        data-path="showOnlyWithErrorsFilter"
      />
      <Button
        disabled={loadingCalculationsButton || loadingGroups}
        loading={loadingCalculationsButton}
        onClick={handleLoadCalculations}
        labelLocale={<FormattedMessage id="calculationsHistory.findCalculations"/>}
      />
    </div>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./source/client/components/calculationsHistory/filters.jsx